import { useApi } from 'api/api-context';
import panic from 'errors/panic';
import { useEffect, useState } from 'react';
import PredefinedDataAutosuggestInputBase from 'components/inputs/predefined-data-autosuggest-input/PredefinedDataAutosuggestInputBase';

interface PredefinedDataAutosuggestInputByTypeNameProps
  extends Omit<React.ComponentProps<typeof PredefinedDataAutosuggestInputBase>, 'predefinedDataTypeId'> {
  predefinedDataTypeName?: string;
  deviceTypeId?: number;
}

/**
 * Wrapper over PredefinedDataAutosuggestInput that resolves predefinedDataTypeId from name and device type.
 */
export default function PredefinedDataAutosuggestInputByTypeName({
  predefinedDataTypeName,
  deviceTypeId,
  ...props
}: PredefinedDataAutosuggestInputByTypeNameProps) {
  const { getAction } = useApi();
  const [predefinedDataTypeId, setPredefinedDataTypeId] = useState<number | undefined>(undefined);

  useEffect(() => {
    if (!predefinedDataTypeName || !deviceTypeId) {
      setPredefinedDataTypeId(undefined);
      return;
    }

    const action = getAction('PredefinedDataListTypes');

    action({
      query: {
        filters: {
          'deviceTypeId.eq': deviceTypeId,
          'name.eq': predefinedDataTypeName,
        },
      },
    })
      .then((response) => {
        const matchedType = response.find((type) => type.name === predefinedDataTypeName);
        setPredefinedDataTypeId(matchedType?.predefinedDataTypeId);
      })
      .catch(panic);
  }, [getAction, predefinedDataTypeName, deviceTypeId]);

  return <PredefinedDataAutosuggestInputBase predefinedDataTypeId={predefinedDataTypeId} {...props} />;
}
